import { t } from "@/i18n-js/instance";
import { Icon } from "@circle-react-shared/Icon";
import { useSelectedBlock } from "../Hooks/useBuilderStore";
import { BlockActionButton } from "./BlockActionButton";

export const Remove = () => {
  const { removeSelectedBlock } = useSelectedBlock();

  const onClickHandler = () => {
    // TODO: Add confirmation modal
    removeSelectedBlock();
  };

  return (
    <BlockActionButton
      onClick={onClickHandler}
      title={t("builder_ui.editor.remove")}
    >
      <Icon type="16-trash" size={16} />
    </BlockActionButton>
  );
};
